import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames';

import { ReactComponent as Back } from 'Icons/back-bordered.svg';
import { ReactComponent as Forward } from 'Icons/forward-bordered.svg';
import Timer from '../Timer';
import Activity from '../Activity';
import { SERVICE_TYPES, 
    RFQ_TABLE_DATE_FORMAT,
    RFQ_TYPE_NAMES,
    SHIPPING_TYPE_NAMES,
    RFQ_VALIDITY_STATUS,
    ROQUETTE,
    BIDDING_TYPE,
    CONTRACT_TENURE_TYPES,
    BEAM,
    POLYCAB,
    RIL,
    ADANI,
    FORSOC,
    CP_STATUS,
    LOI_STATUS_LIST
} from 'Constants/commonConstants';
import Dropdown from 'Components/Dropdown';
import Upload from 'Components/Upload';

import {toPascalCase} from '../../utils/validate'
import { getUser } from 'Utils/storage';
import Cx from 'classnames';
import { isAdaniWilmar, isDesmet, isVishaka } from 'Utils/index';

export default class AllRfqs extends Component {
    getHeaders(status) {
        if(status === 1) {
            return (
                <div className="flex flex-between mb-20 pr-10">
                    <div className="fBold fs-16 header-dark-color pl-15 wt-200">RFQ Name</div>
                    <div className="fBold fs-16 col-8 header-dark-color pl-15">RFQ Type</div>
                    <div className="fBold fs-16 col-8 header-dark-color pl-15">Service Type</div>
                    <div className="fBold fs-16 col-8 header-dark-color pl-15">Mode Type</div>
                    <div className="fBold fs-16 header-dark-color wt-100 pl-15">Created On</div>
                    <div className="fBold fs-16 wt-250 header-dark-color pl-15">Contract Tenure</div>

                </div>
            )
        } else if(status===10 ||status===12) {
            return (
                <div className="flex flex-between mb-20 pr-10">
                    <div className="fBold fs-16 header-dark-color pl-15 wt-200">RFQ Name</div>
                    <div className="fBold fs-16 col-8 header-dark-color pl-15">RFQ Type</div>
                    <div className="fBold fs-16 wt-150 header-dark-color pl-15">Branch Name</div>
                    <div className="fBold fs-16 col-8 header-dark-color pl-15">Service Type</div>
                    <div className="fBold fs-16 col-8 header-dark-color pl-15">Mode Type</div>
                    <div className="fBold fs-16 header-dark-color wt-100 pl-15">Floated On</div>
                    <div className="fBold fs-16 wt-250 header-dark-color pl-15">Contract Tenure</div>
                    

                </div>
            )
        } 
        else if(status===99){
            return <div className="flex flex-between mb-20 pr-50">
                <div className="fBold fs-16 header-dark-color pl-15 wt-250">RFQ Name</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Time Left</div>
                <div className="fBold fs-16 header-dark-color col-6 pl-15">L1 Hits | Plain Hits</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Bids From</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Activity</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Mode Type</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Floated On</div>
            </div>
        }else {
            return <div className="flex flex-between mb-20 pr-50">
                <div className="fBold fs-16 header-dark-color pl-15 wt-250">RFQ Name</div>
                {
                    (status === 5) ? <div className="fBold fs-14 header-dark-color col-4 pl-15">CP
                    <span className="orange-color"> Sent</span> |
                    <span className="success-color"> Accept</span> |
                    <span className="error-color"> Reject</span> 
                    </div> : 
                    <div className="fBold fs-16 header-dark-color col-4 pl-15">
                        {(status === 11) ? 'Success/Error Status' : 'Time Left'}
                    </div>
                }
                <div className="fBold fs-16 header-dark-color col-6 pl-15">L1 Hits | Plain Hits</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Bids From</div>
                {isDesmet() && <>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Suplier Name</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Project ID</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">PO Number</div>
                </>}
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Activity</div>
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Mode Type</div>
                {(status === 5) && <div className="fBold fs-14 header-dark-color col-4 pl-15">LOI <span className="orange-color">Sent</span> | <span className="success-color">Accept</span> | <span className="error-color">Reject</span> | <span className="caption-color">Ignored</span></div>}
                <div className="fBold fs-16 header-dark-color col-4 pl-15">Floated On</div>
                {!this.props.isAdminView && <div className="fBold fs-16 header-dark-color col-4 pl-15">Extend <br />Contract
                </div>}
            </div>
        }
    }

    getServiceNameOfType = (type) => {
        return (SERVICE_TYPES.find((obj) => obj.value === type) || {}).name || '-';
    }
    pickupDraft = (rfq)=> {
        this.props.pickupDraft(rfq);
    }
    navigateRFQBids = (rfq)=> {
        this.props.navigateRFQBids(rfq);
    }
    navigateTK11RFQBids = (rfq) => {
        this.props.navigateTK11RFQBids(rfq);
    }
    navigateToRFQView = (rfq) => {
        this.props.navigateRFQView(rfq);
    }
    extendToRFQView=(e, rfq)=>{
     if(this.rfq!==null){
         localStorage.setItem('state', 'isEnable');
        }
        e.stopPropagation();
        this.props.navigateRFQView(rfq);
    }

    copyRfq = (e, id, rfqType)=> {
        e.stopPropagation();
        this.props.copyRFQ(id, rfqType);
    }

    downloadTrucksTrips =()=>{
       this.props.downloadTrucksDetails();
       
    }

    uploadNumberOfTrucks = (file)=>{
        this.props.uploadNumberOfTrucks(file);
    }

    shouldRenderExtendandCopy = () => {
        const C1 = isVishaka()
        const user = getUser()
        const C2 = user?.is_contract_details_enabled === false
        if (C1 && C2) {
            return true
        }
    }

    getBody(status, rfq, index) {
        let isCancelled="Cancelled";
        let isExtendDateEdit=false;
        const { systemTime} = this.props;
        const user = getUser();
        const actions = user.actions;
        const isCreateRFQ = (actions || []).find(action => action.id == 1);
        const isEditRFQ = (actions || []).find(action => [12,3,1].includes(action.id));
        let isEditContractTenure = (user.isEditContractTenure || user.isAdmin || isEditRFQ);
        if(status===5 ||status===3|| status===6||status==2 || status == 8)
        isExtendDateEdit=isEditContractTenure;
        const disableForVishaka = isVishaka() && this.shouldRenderExtendandCopy();
        if(status === 1) {
            return <div className={`rfq-row pr flex flex-between flex-middle border-top-light pt-25 pb-25 pr-10 bg-hover-light ${disableForVishaka ? 'not-allowed op-50' : 'curP'}`} key={index} onClick={this.pickupDraft.bind(this, rfq)}>
                <div className="fs-14 table-text-color pl-15 fs-14 lh-15p fRegular wt-200">
                    <div className="fs-14 table-text-color fs-14 lh-15p break-word">
						{rfq.rfqDetails.name}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.rfqNumber}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.branchName}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.fuelName}
                    </div>
                    {POLYCAB.includes(rfq.companyId) && rfq.shipmentId && 
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.shipmentId}
                    </div>}
                </div>
                <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p ">{RFQ_TYPE_NAMES[rfq.type]}{rfq && (rfq.type===5) &&<span>({SHIPPING_TYPE_NAMES[rfq.shippingType]})</span>}</div>
                <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p ">{(rfq.type === 8 ? (rfq?.rfqDetails?.serviceModeName) :rfq.serviceTypeName)}</div>
                {/* {(rfq.type === 1) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Single Mode</div> : (rfq.type === 2) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Multi Mode</div> : <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Secondary Mode</div>} */}
                <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">{rfq.type === 8 ? <>{rfq?.rfqDetails?.serviceModeName}</> : <>{RFQ_TYPE_NAMES[rfq.type]}{rfq && (rfq.type===5) &&<span>({SHIPPING_TYPE_NAMES[rfq.shippingType]})</span>}</>}</div>
                <div className="fs-14 table-text-color pl-15 fs-14 lh-15p wt-100">{moment(rfq.created).format(RFQ_TABLE_DATE_FORMAT)}</div>
                <div className="fs-14 table-text-color wt-250 pl-15 fs-14 lh-15p">
                    {rfq.rfqDetails.contractTenureFrom?moment(rfq.rfqDetails.contractTenureFrom).format(RFQ_TABLE_DATE_FORMAT): '-'} 
                    <span className="fBold"> to </span> 
                    {rfq.rfqDetails.contractTenureTo?moment(rfq.rfqDetails.contractTenureTo).format(RFQ_TABLE_DATE_FORMAT):'-'}
                </div>
                {!isDesmet() && <div className="copy-cta flex flex-center flex-middle pa border-theme fSemibold fs-14 br-20 theme-color r-0 ht-30 wt-70" onClick={(e)=>{this.copyRfq(e, rfq.id, rfq.type)}}>
                    Copy
                </div>}
            </div>
        } else if(status===10||status===12) {
            return <Link to={{ pathname: `/seeker/bids/${rfq.id}/${rfq.type}`, state: {
                dashboardActiveView: this.props.status
              }}} className="rfq-row pr flex flex-between flex-middle border-top-light pt-25 pb-25 pr-10 bg-hover-light curP" key={index} >
                <div className="fs-14 table-text-color pl-15 fs-14 lh-15p fRegular wt-200">
                    <div className="fs-14 table-text-color fs-14 lh-15p break-word">
                        {rfq.rfqDetails.name}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.rfqNumber}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.branchName}
                    </div>
                    {rfq.fuelName && <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.fuelName}
                    </div>}
                </div>
					<div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p ">{toPascalCase(RFQ_TYPE_NAMES[rfq.type])}</div>
                <div className="fs-14 table-text-color wt-150 pl-15 fs-14 lh-15p ">{rfq.branchName}</div>
                <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p ">{(rfq.type === 8 ? (rfq?.rfqDetails?.serviceModeName) :rfq.serviceTypeName)}</div>
                {/* {(rfq.type === 1) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Single Mode</div> : (rfq.type === 2) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Multi Mode</div> : <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Secondary Mode</div>} */}
                <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">{RFQ_TYPE_NAMES[rfq.type]}</div>
                <div className="fs-14 table-text-color pl-15 fs-14 lh-15p wt-100">{moment(rfq.created).format(RFQ_TABLE_DATE_FORMAT)}</div>
                <div className="fs-14 table-text-color wt-250 pl-15 fs-14 lh-15p">
                    {rfq.rfqDetails.contractTenureFrom?moment(rfq.rfqDetails.contractTenureFrom).format(RFQ_TABLE_DATE_FORMAT): '-'} 
                    <span className="fBold"> to </span> 
                    {rfq.rfqDetails.contractTenureTo?moment(rfq.rfqDetails.contractTenureTo).format(RFQ_TABLE_DATE_FORMAT):'-'}
                </div>
            </Link>
        } else if(status === 99){
            return <div 
            className="rfq-row flex flex-between flex-middle border-top-light pt-25 pb-25 bg-hover-light pr pr-50 curP" 
            key={index} 

            onClick={() => {
                if (status === 99) {
                    if (disableForVishaka) return;
                    this.navigateToRFQView(rfq)
                } else {
                    if (disableForVishaka) return;
                    this.navigateRFQBids(rfq)
                }
            }}>
                <div className="pl-15  wt-250">
                    <div className="fs-14 table-text-color fs-14 lh-15p fRegular break-word">
							{rfq.rfqDetails.name}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.rfqNumber}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.branchName}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.fuelName}
                    </div>
                </div>
                
                <div className="fs-14 table-text-color col-4 pl-15"> {isCancelled}</div>
                <div className="fs-14 table-text-color col-6 pl-15 fs-14 lh-15p  ">{rfq.l1Hits || 0} <b className="theme-color"> | </b> {rfq.hits}</div>
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p first-letter-semi-bold ">{rfq.bids}</div>
                <div className="fs-14 table-text-color col-4 pl-15"> <Activity activity={rfq.activity || {}} /> </div>
                {/* {(rfq.type === 1) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Single Mode</div> : (rfq.type === 2) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Multi Mode</div> : <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Secondary Mode</div>} */}
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p">{rfq.type === 8 ? <>{rfq?.rfqDetails?.serviceModeName}</> : <>{RFQ_TYPE_NAMES[rfq.type]}{ rfq && (rfq.type===5) &&<span>({SHIPPING_TYPE_NAMES[rfq.shippingType]})</span>}</>}</div>
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p">{moment(rfq.created).format(RFQ_TABLE_DATE_FORMAT)}</div>
                {!isDesmet() && <div className="copy-cta flex flex-center flex-middle pa border-theme fSemibold fs-14 br-20 theme-color r-0 ht-30 wt-70" onClick={(e)=>{this.copyRfq(e, rfq.id, rfq.type)}}>
                    Copy
                </div>}
            </div>
        } else if(status === 11){
            return <div 
            className="rfq-row flex flex-between flex-middle border-top-light pt-25 pb-25 bg-hover-light pr pr-50 curP" 
            key={index} 

            onClick={() => {
                if (status === 11) {
                    if (disableForVishaka) return;
                    this.navigateTK11RFQBids(rfq)
                } else {
                    if (disableForVishaka) return;
                    this.navigateRFQBids(rfq)
                }
            }}>
                <div className="pl-15  wt-250">
                    <div className="fs-14 table-text-color fs-14 lh-15p fRegular break-word">
							{rfq.rfqDetails.name}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.rfqNumber}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.branchName}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.fuelName}
                    </div>
                </div>
                
                <div className="fs-14 table-text-color col-4 pl-15"> <span className="success-color">{rfq.tkSuccessCount}</span> / <span className="error-color">{rfq.tkFailureCount}</span> </div>
                <div className="fs-14 table-text-color col-6 pl-15 fs-14 lh-15p  ">{rfq.l1Hits || 0} <b className="theme-color"> | </b> {rfq.hits}</div>
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p first-letter-semi-bold ">{rfq.bids}</div>
                <div className="fs-14 table-text-color col-4 pl-15"> <Activity activity={rfq.activity || {}} /> </div>
                {/* {(rfq.type === 1) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Single Mode</div> : (rfq.type === 2) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Multi Mode</div> : <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Secondary Mode</div>} */}
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p">{rfq.type === 8 ? <>{rfq?.rfqDetails?.serviceModeName}</> : <>{RFQ_TYPE_NAMES[rfq.type]}{rfq && (rfq.type===5) &&<span>({SHIPPING_TYPE_NAMES[rfq.shippingType]})</span>}</>}</div>
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p">{moment(rfq.created).format(RFQ_TABLE_DATE_FORMAT)}</div>
                {!isDesmet() && <div className="copy-cta flex flex-center flex-middle pa border-theme fSemibold fs-14 br-20 theme-color r-0 ht-30 wt-70" onClick={(e)=>{this.copyRfq(e, rfq.id, rfq.type)}}>
                    Copy
                </div>}
            </div>
        } else {
            return <div
            className="rfq-row flex flex-between flex-middle border-top-light pt-25 pb-25 bg-hover-light pr pr-50 curP"
            key={index}
            onClick={
                () => {
                    // if (disableForVishaka) return;
                    if (this.props.isAdminView) {
                        this.navigateToRFQView(rfq);
                    } else {
                        this.navigateRFQBids(rfq);
                    }
                }
            }
            >
                <div className="pl-15  wt-250">
                    <div className="fs-14 table-text-color fs-14 lh-15p fRegular break-word">
							{rfq.rfqDetails.name}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.rfqNumber}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.branchName}
                    </div>
                    <div className="mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        {rfq.fuelName}
                    </div>
                    { this.conditionsToRenderPOSTBid(rfq) &&
                    <div className="mt-2 fSemibold orange-color1 fs-12 lh-15p">
                        POST BID
                    </div>}
                    {this.conditionsToRenderPREBid(rfq) &&
                    <div className="mt-2 fSemibold orange-color1 fs-12 op-79 lh-15p">
                        PRE BID
                    </div>}
                    {ADANI.includes(rfq.companyId) && rfq.type === 9 && rfq.disposal_contract_type &&
                    <>
                    <div style={{color:'blue'}}>{(rfq.disposal_contract_type===1)?'Depot Wise':((rfq.disposal_contract_type===2)?'Zone Wise':'')}</div>
                    </>}

                   {rfq.original_rfq_number && <div className=" mt-2 fSemibold table-text-color fs-12 op-79 lh-15p">
                        Old RFQ {rfq.original_rfq_number}
                    </div>}
                    {/* {rfq.rfqDetails.contractNote && <div className="mt-2 fBold table-text-color fs-12 op-79 lh-15p">
                        <b>Note: </b>  <span className="error-color">{rfq.rfqDetails.contractNote}</span>
                    </div>} */}
                    {rfq.type != 9 && <div>
                        {(rfq.rfqDetails.contractTenureTo && rfq.rfqDetails.contractTenureTo > new Date()) ? <span className='fs-14 fBold success-color'>Active</span> : <span className='fs-14 fBold error-color'> Expired </span>}
                    </div>}
                    {(rfq.type != 9 && (rfq.activeContractCountBid || rfq.expiredContractCountBid)) && 
                    <div>
                       {/* {(rfq.activeContractCountBid>0&&  <span className='fs-10 fBold success-color'>Active Lanes ({rfq.activeContractCountTrip})</span>) }
                        {(rfq.expiredContractCountTrip>0 &&<span className='fs-10 fBold error-color'> Expired Lanes ({rfq.expiredContractCountTrip})</span>)} */}
                        {(rfq.activeContractCountBid > 0 && !rfq.expiredContractCountBid) && <span className='fs-10 fBold success-color'>Active</span>}
                        {(rfq.activeContractCountBid > 0 && rfq.expiredContractCountBid > 0) && <span className='fs-10 fBold orange-color'>Partially Active</span>}
                        {(!rfq.activeContractCountBid && rfq.expiredContractCountBid > 0) && <span className='fs-10 fBold error-color'>Expired</span>}
                    </div> || ''}
                </div>
                
                {
                    (status === 5) ? <div className="fs-14 table-text-color col-4 pl-15">
                        <span className="orange-color">{rfq.noOfCounterpriceSent || 0}</span>
                        <span className="fBold fs-18"> | </span>
                        <span className="success-color">{rfq.noOfCounterpriceAccepted || 0}</span>
                        <span className="fBold fs-18"> | </span>
                        <span className="error-color">{rfq.noOfCounterpriceRejected || 0}</span>
                        </div>
                        :
                        <div className="fs-14 table-text-color col-4 pl-15">
                            <div className="fs-12 table-text-color op-79 lh-15p pb-5">
                             {moment(rfq.rfqDetails.biddingStart).format('Do MMM, YYYY h:mm:ss a')}
                           </div>
                             <span className="fBold fs-14"> to </span>
                          <div className="fs-12 table-text-color op-79 lh-15p pb-5 ml-15-resp min-w-180 mt-0">
                              {moment(rfq.rfqDetails.biddingEnd).format('Do MMM, YYYY h:mm:ss a')}
                           </div>
                            <Timer from={rfq.rfqDetails.biddingStart} to={rfq.rfqDetails.biddingEnd} currentTime={systemTime} />
                        </div>
                }                
                <div className="fs-14 table-text-color col-6 pl-15 fs-14 lh-15p  ">{rfq.l1Hits || 0} <b className="theme-color"> | </b> {rfq.hits}</div>
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p first-letter-semi-bold ">{rfq.bids}</div>
                {isDesmet() && <>
                    <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p ">{rfq.supplier_name || "-"}</div>
                    <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p ">{rfq.project_id || "-"}</div>
                    <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p ">{rfq.po_number || "-"}</div>
                </>}
                <div className="fs-14 table-text-color col-4 pl-15"> <Activity activity={rfq.activity || {}} /> </div>
                {/* {(rfq.type === 1) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Single Mode</div> : (rfq.type === 2) ? <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Multi Mode</div> : <div className="fs-14 table-text-color col-8 pl-15 fs-14 lh-15p">Secondary Mode</div>} */}
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p">{rfq.type === 8 ? <>{rfq?.rfqDetails?.serviceModeName}</> : <>{RFQ_TYPE_NAMES[rfq.type]}{ rfq && (rfq.type===5) &&<span>({SHIPPING_TYPE_NAMES[rfq.shippingType]})</span>}</>}</div>
                {(status===5) && <div className="fs-14 table-text-color col-4 pl-15"><span className="orange-color">{rfq.noOfLoiSent}</span><span className="fBold fs-18"> | </span><span className="success-color">{rfq.noOfLoiAccepted}</span> <span className="fBold fs-18"> | </span> <span className="error-color">{rfq.noOfLoiRejected}</span> <span className="fBold fs-18"> | </span> <span color="caption-color">{rfq.pending}</span>
                 </div>}
                <div className="fs-14 table-text-color col-4 pl-15 fs-14 lh-15p">{moment(rfq.created).format(RFQ_TABLE_DATE_FORMAT)}</div>
                {!this.props.isAdminView && <div className='col-4 '>
                {!isVishaka() && isExtendDateEdit &&  <div
                    className="fs-14 fSemibold flex col-4 pl-15 lh-15p theme-color" onClick={(e)=>{this.extendToRFQView(e, rfq)}}>
                 Extend
                </div>
                  }
                {isVishaka() && isExtendDateEdit && <div
                 className={Cx(
                    "fs-14 fSemibold flex col-4 pl-15 lh-15p theme-color",
                    { "not-allowed opacity-50": disableForVishaka }
                )}
                onClick={(e) => {
                if (disableForVishaka) return;
                this.extendToRFQView(e, rfq);
                }}
                >
                Extend
                </div>
                }
                </div>
                }
                {!this.props.isAdminView && !isVishaka() &&(isCreateRFQ && !isDesmet()) &&
                <div className="copy-cta flex flex-center flex-middle pa border-theme fSemibold fs-14 br-20 theme-color r-0 ht-30 wt-70 " onClick={(e)=>{this.copyRfq(e, rfq.id, rfq.type)}}>
                Copy
                </div>
                }
                {!this.props.isAdminView && isVishaka() && (isCreateRFQ && !isDesmet()) && (
                    <div
                        className={Cx(
                            "copy-cta flex flex-center flex-middle pa border-theme fSemibold fs-14 br-20 theme-color r-0 ht-30 wt-70",
                            // { "not-allowed opacity-50": disableForVishaka }
                        )}
                        onClick={(e) => {
                            // if (disableForVishaka) return;
                            this.copyRfq(e, rfq.id, rfq.type);
                        }}
                    >
                        Copy
                    </div>
                )}
            </div>
        }
    }

    shouldRenderFrontAndBack =()=>{
        const user = getUser();
        const isBeam = BEAM.includes(user.companyId);
        const isFosroc = FORSOC.includes(user.companyId);
        if(isBeam || isFosroc){
            return false;
        }
        return true;   
     }
    shouldRenderPaginationButtons =()=>{
        const user = getUser();
        const isBeam = BEAM.includes(user.companyId);
        const isFosroc = FORSOC.includes(user.companyId);
        if(isBeam || isFosroc){
            return true;
        }
        return false;   
     }

     conditionsToRenderPOSTBid =(rfq)=>{
        const user = getUser();
        const C1 = RIL.includes(rfq.companyId);
        const C2 = rfq.bidding_type === 1;
        if(C1 && C2){
            return true;
        }
        return false;   
     }

     conditionsToRenderPREBid =(rfq)=>{
        const user = getUser();
        const C1 = RIL.includes(rfq.companyId);
        const C2 = rfq.bidding_type === 2;
        if(C1 && C2){
            return true;
        }
        return false;    
     }

     getRFQTypes = () => {
        let { rfqTypesList } = this.props;
        let rfqTypes = [];
        const user = getUser();
        rfqTypesList = rfqTypesList.filter(rfqType => user.rfqTypes.includes(rfqType.rfq_type));
        (rfqTypesList || []).forEach(el => {
            if(!el.sub_rfq_types || (el.sub_rfq_types || []).filter(rfqType => user.rfqTypes.includes(rfqType.rfq_type)).length == 0) {
                rfqTypes.push(el);
            } else {
                (el.sub_rfq_types || []).forEach(subType => {
                    rfqTypes.push(subType)
                })
            }
        });
        return rfqTypes;
     }

    render() {
        const { rfqs, status, goToNextPage, goToPrevPage, limit, offset, gettingRfqs, rfqType, onRFQTypeSelect, onSelect, branchesList, rfqActiveStatus, branchId, biddingType, user_name_list, user, contractType,loiCount, cpStatus, loiStatus, boundType} = this.props;
        const rfqTypesList  = this.getRFQTypes();
        const isUploadNumberOfTrucks =getUser().uploadNumberOfTrucks;
        (rfqTypesList || []).forEach(list => {
            list.name = (list.name || '').replace('AWL ', '');
         });
        const userList = (user_name_list || []).map(el =>{ return {name: el, value: el} });
        return (
            <div className="box-shadow br-5 pl-15 pr-15 pt-15 pb-15 mt-20 ml-40 w-150 mt-5 top-nav-responsive ">

            <div className=' sticky-Contract-type-header'>

                <div className="flex flex-between mb-30">
                    {
                        status === 1 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">Draft RFQs</div>
                    }
                    {
                        status === 2 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">Active RFQ`s</div>
                    }
                    {
                        status === 3 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">RFQs In Bidding</div>
                    }
                    {
                        status === 8 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">LOI/CP Stage RFQs</div>
                    }
                    {
                        status === 5 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">Closed RFQ's</div>
                    }
                    {
                        status === 9 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">LOI RFQ's</div>
                    }
                    {
                        status === 6 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">Contracts</div>
                    }
                    {
                        status === 10 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">RFQs Pending For Approval</div>
                    }
                    {
                        status === 12 && <div className="fBold fs-22 rfq-table-title pl-10 pt-20 pb-20 header-medium-color">RFQs Approved List</div>
                    }
                    
                    <div className="flex flex-middle">
                        { status === 5 &&  isUploadNumberOfTrucks && 
                    <button className="ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => { this.downloadTrucksTrips()}}>Download Trucks</button>
                   
                        }
                         {status === 5 && isUploadNumberOfTrucks && <Upload onChange={this.uploadNumberOfTrucks}>
							<button className={classNames("ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30", {
                        		disabled : this.props.disableUploadTrucks })}>Upload Trucks</button>
                        </Upload>} 

                    {(ROQUETTE.includes(getUser().companyId) && [5, 9].includes(status)) && <>
                       <Dropdown 
                            className="wt-200 mr-20"
                            label="Select Branch"
                            items={branchesList}
                            displayKey="label"
                            onSelect = {(option) => onSelect('branchId', option)}
                            selectedItem = {branchId && (branchesList || []).find(list =>list.value === branchId) || null}
                            canClear={true}
                        />
                        <Dropdown 
                            className="wt-150 mr-20"
                            label="Bidding Type"
                            items={BIDDING_TYPE}
                            displayKey="name"
                            onSelect = {(option) => onSelect('biddingType', option)}
                            selectedItem = {biddingType && (BIDDING_TYPE || []).find(list =>list.value === biddingType) || null}
                            canClear={true}
                        />

                        {/* {[9].includes(status) &&  */}
                        <Dropdown 
                            className="wt-150 mr-20"
                            label="RFQ Status"
                            items={RFQ_VALIDITY_STATUS}
                            displayKey="name"
                            onSelect = {(option) => onSelect('rfqActiveStatus', option)}
                            selectedItem = {rfqActiveStatus && (RFQ_VALIDITY_STATUS || []).find(list =>list.value === rfqActiveStatus) || null}
                            canClear={true}
                        />
                    </>}
                    {isVishaka() && <>
                        <Dropdown
                            className="wt-200 mr-20"
                            label="Select Branch"
                            items={branchesList}
                            displayKey="label"
                            onSelect={(option) => onSelect('branchId', option)}
                            selectedItem={branchId && (branchesList || []).find(list => list.value === branchId) || null}
                            canClear={true}
                        />
                        <Dropdown
                            className="wt-200 mr-20"
                            label="Bound Type"
                            items={[{ name: 'Inbound', value: 1 }, { name: 'Outbound', value: 2 }]}
                            displayKey="name"
                            onSelect={(option) => onSelect('boundType', option)}
                            selectedItem={boundType && [{ name: 'Inbound', value: 1 }, { name: 'Outbound', value: 2 }].find(i => i.value === boundType) || null}
                            canClear={true}
                        />
                    </>}

                    {ROQUETTE.includes(getUser().companyId) &&
                        <>
                            {userList.length > 0 && <Dropdown 
                                className="wt-150 mr-20"
                                label="Select user"
                                items={userList}
                                displayKey="name"
                                onSelect = {(option) => onSelect('user', option)}
                                selectedItem = {user && (userList || []).find(list =>list.value === user) || null}
                                canClear={true}
                            />}
                            {[5, 9].includes(status) && <Dropdown 
                                className="wt-180 mr-20"
                                label="Contract Type"
                                items={CONTRACT_TENURE_TYPES}
                                displayKey="name"
                                onSelect = {(option) => onSelect('contractType', option)}
                                selectedItem = {contractType && (CONTRACT_TENURE_TYPES || []).find(list =>list.value === contractType) || null}
                                canClear={true}
                            />}
                        </>
                    }
                    {
                        (FORSOC.includes(getUser().companyId) && [5].includes(status)) && 
                        <>
                           <Dropdown 
                                className="wt-180 mr-20 mt-20"
                                label="CP Status"
                                items={CP_STATUS}
                                displayKey="name"
                                onSelect = {(option) => onSelect('cpStatus', option)}
                                selectedItem = {cpStatus && (CP_STATUS || []).find(list =>list.value === cpStatus) || null}
                                canClear={true}
                            />
                            <Dropdown 
                                className="wt-180 mr-20 mt-20"
                                label="LOI Status"
                                items={LOI_STATUS_LIST}
                                displayKey="name"
                                onSelect = {(option) => onSelect('loiStatus', option)}
                                selectedItem = {loiStatus && (LOI_STATUS_LIST || []).find(list =>list.value === loiStatus) || null}
                                canClear={true}
                            />
                        </>
                    }
                        
                   <div>
                            {this.shouldRenderPaginationButtons()&& 
                                                <div className='ml-30'>{this.props.renderPaginationButtons}</div>
                                }

                            {!(ROQUETTE.includes(getUser().companyId)) && <Dropdown 
                                className="wt-200 mr-20 rfqtypedropdown"
                                label="Select RFQ Type"
                                items={isAdaniWilmar() ? (rfqTypesList || []).filter(list => [1,3,6,9,10].includes(list.id)) : rfqTypesList}
                                displayKey="name"
                                onSelect = {onRFQTypeSelect}
                                selectedItem = {rfqType && (rfqTypesList || []).find(list =>list.id === rfqType) || null}
                                canClear={true}
                            />}
                    </div>
                    
                        {this.shouldRenderFrontAndBack()&&
                        <div>
                            {
                                offset < limit && <Back className="mr-10"/>
                            }
                            {
                                offset >= limit && <Forward className="mr-10 rotate-180deg curP" onClick={goToPrevPage}/>
                            }
                            {
                                rfqs && rfqs.length >= 10 && <Forward className="mr-10 curP" onClick={goToNextPage} />
                            }
                            {                  
                                rfqs && ( rfqs.length == 0 || rfqs.length < 10 ) && <Back className="mr-10 rotate-180deg"/>
                            }
                        </div>}

                            </div>
                                    
                </div>

                    <div>
                        {this.getHeaders(status)}
                    </div>

            </div>
                {
                    (rfqs || []).map((rfq, index)=> {
                        return this.getBody(status, rfq, index);
                    })
                }
                {   !(rfqs && rfqs.length > 0) &&  !gettingRfqs && 
                    <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No RFQ Has Been Added</div>
                }
            </div>
        )
    }
}

